import React from 'react';
import { Video } from 'lucide-react';

const LivePage = () => {
  return (
    <div className="min-h-screen bg-black">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 py-16">
        <div className="text-center py-20">
          <Video className="w-24 h-24 text-orange-500 mx-auto mb-6" />
          <h1 className="text-4xl font-black text-white mb-4">Live</h1>
          <p className="text-xl text-gray-400 mb-8">
            Watch creators livestream their creative process
          </p>
          <p className="text-gray-500">
            Coming soon! This feature is currently in development.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LivePage;